import { StatusSession } from '../../constants';
import { handleErrorInfo } from '../../utils';
import { AuthActionType } from './actions';
import { AuthState } from './interfaces';
import { getRolesFromToken } from '../../utils/jwt';

const initialState: AuthState = {
  loading: false,
  error: false,
  errorInfo: undefined,
  token: undefined,
  tokenExpiration: undefined,
  impersonationAdminEmail: undefined,
  isAuthenticated: false,
  sessionStatus: StatusSession.UNDEFINED,
  logout: false,
  checkSessionCompleted: false,
  afterLoginSuccess: false,
  roles: [],
};

const AuthReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case AuthActionType.INIT_LOGIN: {
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: undefined,
      };
    }
    case AuthActionType.INIT_CHECK_COMPLETED: {
      return {
        ...state,
        checkSessionCompleted: true,
        sessionStatus: state.token ? state.sessionStatus : StatusSession.LOGGED_OUT,
      };
    }
    case AuthActionType.SENDING_LOGIN: {
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: undefined,
      };
    }
    case AuthActionType.LOGIN_SUCCESS: {
      const token = action.response.token;
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: undefined,
        token,
        tokenExpiration: action.response.tokenExpiration,
        impersonationAdminEmail: action.response.impersonationAdminEmail,
        isAuthenticated: true,
        sessionStatus: StatusSession.LOGGED_IN,
        afterLoginSuccess: true,
        roles: getRolesFromToken(token),
      };
    }
    case AuthActionType.LOGIN_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: handleErrorInfo(AuthActionType.LOGIN_ERROR, action.error),
      };
    }
    case AuthActionType.REFRESH_TOKEN: {
      const token = action.response.token;
      return {
        ...state,
        token,
        tokenExpiration: action.response.tokenExpiration,
        impersonationAdminEmail: state.impersonationAdminEmail,
        isAuthenticated: true,
        sessionStatus: StatusSession.LOGGED_IN,
        roles: getRolesFromToken(token),
      };
    }
    case AuthActionType.SET_IMPERSONATION_ADMIN_EMAIL: {
      return {
        ...state,
        impersonationAdminEmail: action.email,
      };
    }
    case AuthActionType.TOKEN_CHECKED: {
      return {
        ...state,
      };
    }
    case AuthActionType.SEND_LOGOUT: {
      return {
        ...state,
        logouting: true,
      };
    }
    case AuthActionType.LOGOUT_SUCCESS:
      return {
        ...state,
        token: undefined,
        tokenExpiration: undefined,
        impersonationAdminEmail: undefined,
        isAuthenticated: false,
        sessionStatus: StatusSession.LOGGED_OUT,
        roles: [],
      };
    case AuthActionType.REFRESH_TOKEN_ERROR:
    case AuthActionType.LOGOUT_ERROR: {
      return {
        ...state,
        token: undefined,
        tokenExpiration: undefined,
        impersonationAdminEmail: undefined,
        isAuthenticated: false,
        sessionStatus: StatusSession.INVALID,
        roles: [],
      };
    }
    default:
      return state;
  }
};

export default AuthReducer;
